import { render, staticRenderFns } from "./base_review.vue?vue&type=template&id=0fbadcd2&scoped=true&"
import script from "./base_review.vue?vue&type=script&lang=js&"
export * from "./base_review.vue?vue&type=script&lang=js&"
import style0 from "./base_review.vue?vue&type=style&index=0&id=0fbadcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbadcd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbadcd2')) {
      api.createRecord('0fbadcd2', component.options)
    } else {
      api.reload('0fbadcd2', component.options)
    }
    module.hot.accept("./base_review.vue?vue&type=template&id=0fbadcd2&scoped=true&", function () {
      api.rerender('0fbadcd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/base/base_review.vue"
export default component.exports